document.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
        document.querySelector('.site-header').classList.add('uk-active');
    } else {
        document.querySelector('.site-header').classList.remove('uk-active');
    }
})

let slideshow = UIkit.slideshow('.slider'),
    ratios = {
        'large': '64:32',
        'medium': '3:2',
        'small': '1:1',
        'xsmall': '3:4',
        'xxsmall': '1:2'
    };

if (slideshow) {
    setSlideshowRatio();
    window.addEventListener('resize', setSlideshowRatio);
}

function setSlideshowRatio() {
    if (window.innerWidth <= 639) {
        slideshow.ratio = ratios.xxsmall;
    }else if (window.innerWidth <= 959) {
        slideshow.ratio = ratios.xsmall;
    } else if (window.innerWidth <= 1199) {
        slideshow.ratio = ratios.small;
    } else if (window.innerWidth <= 1599) {
        slideshow.ratio = ratios.medium;
    } else {
        slideshow.ratio = ratios.large;
    }
}
